module.exports = __webpack_public_path__ + "aaffc6d7431600a2bb9a3d3614576146.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/picture/Stanley.jpg
// module id = 493
// module chunks = 0